import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';

import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function ComaScale(props){

  const {ip_id} = useParams();
  const [ipData, setIpData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());
  const [comaData, setcomaData] = useState([]);
  const [nurseData,setnurseData]=useState({
        "ip":'',
        "notes":'',
        "notes_time":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchData();
  }, []);

  function fetchData() {
    axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
      .then(response => {
        setIpData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
   const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };

   useEffect(() => {
        fetchcomaData();
   }, []);
    function fetchcomaData() {
      axios.get(baseUrl + "view-nurse-notes/" + ip_id + "/")
        .then(response => {
          setcomaData(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    }

  const formSubmit = (e) => {
      e.preventDefault();
         const notes = document.getElementById("notes").value;
         const notes_time = document.getElementById("notes_time").value;
          const _formData = new FormData();
          _formData.append('ip', ip_id);
          _formData.append('notes', notes);
          _formData.append('notes_time', notes_time);
          _formData.append('status', '1');
          _formData.append('addedby', userName);
          _formData.append('ip_add', ipAddress);
          _formData.append('location', userLocation);

          axios.post(`${baseUrl}nurse-notes-create/`, _formData)
            .then(response => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Notes Created Succesfully',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setnurseData({
                  ip: '',
                  notes: '',
                  notes_time: '',
                  status: '',
                  addedby: '',
                  ip_add: '',
                });
                setTimeout(() => {
                  window.location.href = '/nurse-pat-view/'+ ip_id +'/';
                }, 3000);
              }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
            });
  };
  const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result)=>{
            if(result.isConfirmed){
               try{
                   axios.delete(baseUrl+'delete-nurse-notes/'+id+'/')
                   .then(function (response) {
                      Swal.fire('success', 'Data has been Deleted');
                    });
                    setTimeout(() => {
                    window.location.href = ('/nurse-notes/'+ip_id+'/');
                    }, 3000);
               }catch(error){
                    Swal.fire('error', 'Data has not been deleted');
               }
            }else{
                  Swal.fire('error', 'Data has not been deleted');
            }

        })
    }

    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{ipData.map(row => row.primary_consult.consultant)}
    </h3>
     <div className="table-responsive">
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {ipData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip_id}</td>
            <td>{patientData.pat.pat_id}</td>
            <td>{patientData.pat.patient}</td>
            <td>{patientData.pat.gender}</td>
            <td>{patientData.pat.age}</td>
            <td>{patientData.pat.mobile}</td>
            <td>{formatDateTime(patientData.admit_date)}</td>
          </tr>
        ))}
      </tbody>
        </table>
     </div>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-user-nurse" aria-hidden="true" style={{ color: 'red' }}></i>
        Coma Scale
        </h3>
    <table style={{borderCollapse: 'collapse'}}>
      <tr style={{border: '1px solid black', padding: '8px'}}>
        <th width="10%">Time taken</th>
        <th colspan="4">Eyes Open</th>
        <th colspan="5">Best Verbal Response</th>
        <th colspan="10">Best Motor Response</th>
      </tr>
      <tr style={{border: '1px solid black', padding: '8px'}}>
        <td width="5%">Spontaneous</td>
        <td width="8%">To Speech</td>
        <td width="8%">To Pain</td>
        <td width="8%">None</td>
        <td width="8%">Oriented</td>
        <td width="8%">Confused</td>
        <td width="8%">Inapprop<br />words</td>
        <td width="8%">Incompre<br />Sounds</td>
        <td width="8%">None</td>
        <td width="8%">Obey Command</td>
        <td width="8%">Localise pain</td>
        <td width="8%">Withdrawal</td>
        <td width="8%">Flexion to pain</td>
        <td width="8%">Extension to pain</td>
        <td width="8%">None</td>
        <td width="8%">Instructions</td>
      </tr>
    </table>

      <form>
      <div className="row">
        <div className="col-md-6">
          <label htmlFor="Notes" className="form-label">Notes : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="notes"
          id="notes"
          required
        ></textarea>

        </div>

        <div className="col-md-3 ms-1">
          <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
          <DatePicker className="form-control" name="notes_time" id="notes_time" selected={selectedDateTime}
                            onChange={handleDateTimeChange}
                            dateFormat="yyyy-MM-dd h:mm"
                            showTimeSelect
                            timeIntervals={15}
                            timeCaption="Time"
                        />
        </div>
       </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>
              <div className="card card-body">
              <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="fa-solid fa-user-nurse" aria-hidden="true" style={{ color: 'red' }}></i>
                  Coma Scale History
                  <i className="fa-brands fa-discourse"></i>
                    </h3>
               <div className="table-responsive">
              <table className="erp-table-modern">
              <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                      <th>Date</th>
                      <th>Notes</th>
                      <th>Delete</th>
                    </tr>
              </thead>
              <tbody>
                {comaData.map((dis, index) => (
                      <tr >
                        <td>{formatDateTime(dis.notes_time)}</td>
                        <td>{dis.notes}</td>
                        <td>
                          <button className="btn btn-danger" type="button" onClick={() => handleDelete(dis.id)}>
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
                </table>
              </div>
              </div>
    </div>
    </section>
    )
}

export default ComaScale;